// extracted by mini-css-extract-plugin
export default {"innerWrapper":"uu-z","tooltipWrapper":"vu-z","icon":"wu-z","tooltip":"xu-z","content":"yu-z"};